export const isCanceledApiRequest = (error) => {
  const normalizedMessage = String(error?.message || "")
    .trim()
    .toLowerCase();

  return (
    error?.__CANCEL__ === true ||
    error?.code === "ERR_CANCELED" ||
    error?.name === "CanceledError" ||
    error?.config?.signal?.aborted === true ||
    normalizedMessage === "canceled" ||
    normalizedMessage === "cancelled"
  );
};
